import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoForSection() {
  return <SectionWrapper alternate data-id="element-490">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-12" variants={childVariants} data-id="element-491">
        Who this is for
      </motion.h2>

      {/* For You */}
      <motion.div className="mb-12" variants={childVariants} data-id="element-492">
        <p className="font-heading text-lg text-teal-light mb-6" data-id="element-493">
          This is for you if:
        </p>
        <ul className="space-y-4" data-id="element-494">
          <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-495">
            <CheckIcon className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-496" />
            You're a woman 45+
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-497">
            <CheckIcon className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-498" />
            You fall asleep but wake up between 2–4am
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-499">
            <CheckIcon className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-500" />
            You feel wired, anxious, hot, or mentally "on"
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-501">
            <CheckIcon className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-502" />
            <span data-id="element-503">
              You're tired of tips and want a{' '}
              <em className="text-amber" data-id="element-504">protocol</em>
            </span>
          </li>
        </ul>
      </motion.div>

      {/* Not For You */}
      <motion.div variants={childVariants} data-id="element-505">
        <p className="font-heading text-lg text-cream-muted mb-6" data-id="element-506">
          This is not for you if:
        </p>
        <ul className="space-y-4" data-id="element-507">
          <li className="flex items-start gap-3 font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-508">
            <XIcon className="w-5 h-5 text-cream-faint mt-1 flex-shrink-0" data-id="element-509" />
            You want a guaranteed cure
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-510">
            <XIcon className="w-5 h-5 text-cream-faint mt-1 flex-shrink-0" data-id="element-511" />
            You need medical diagnosis/treatment advice
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-512">
            <XIcon className="w-5 h-5 text-cream-faint mt-1 flex-shrink-0" data-id="element-513" />
            You suspect sleep apnea and haven't been evaluated
          </li>
        </ul>
      </motion.div>
    </SectionWrapper>;
}